import Form from "../../utilities/script/form";
import Swal from "sweetalert2";
const downloadExamGuide = new Form(
  document.querySelector("#download-exam-guide"),
);


Array.from(
  document.querySelectorAll('[data-open-modal="download-exam-guide"]'),
).forEach((btn) => {
  btn.addEventListener("click", (event) => {
    const dataset = event.currentTarget.dataset;
    downloadExamGuide.modal.querySelector("input[name=course-id]").value =
      dataset.courseId;
    downloadExamGuide.modal.querySelector("input[name=request-type]").value =
      dataset.requestType;
    downloadExamGuide.modal.querySelector("input[name=lsource]").value =
      dataset.lsource;
  });
});

// E book Submittion
downloadExamGuide.validate.onSuccess(async (event) => {
  try {
    const guideFormData = new FormData(event.target);
    guideFormData.append("website-link", window.location.href);

    downloadExamGuide.modal.classList.add("loading");

    let response = await fetch("/wp-content/themes/s2-labs/student-form.php", {
      body: guideFormData,
      method: "POST",
    });

    if (!response.ok) throw Error("Something Went Wrong");

    let textData = await response.text();
    if (textData.indexOf('Technical Error') > 0) {
      Swal.fire({
        title: "Error!",
        text: "Something went wrong! Please try again after sometime...",
        icon: "error",
        confirmButtonText: "Close",
      });
      window.location.href = window.location.href + '?cachebuster=' + new Date().getTime();
      return false;
    }

    fbq('track', 'CompleteRegistration');
    Swal.fire({
      title: "Thank You",
      text: "Your FREE Certification Guide is on its way to your inbox.",
      icon: "success",
      confirmButtonText: "Close",
    });
  } catch {
    Swal.fire({
      title: "Error!",
      text: "Something went wrong! Please try again after sometime...",
      icon: "error",
      confirmButtonText: "Close",
    });
  } finally {
    downloadExamGuide.modal.classList.remove("loading");
    downloadExamGuide.modal.querySelector("form").reset();
    downloadExamGuide.toggleModal();
  }
});
